export default "__VITE_ASSET__116628ae__"